import React from 'react';
import { ArrowDownIcon, RmxCheckIcon, AddIcon } from 'cokitchen-icons';
import useDashboardContext from 'contexts/dashboard.context';

import { ReactComponent as GeneralDashboardIcon } from '../../assets/icons/general-store-dashboard.svg';
import { MAIN_STORE_ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { Link, useNavigate } from 'react-router-dom';
import { StoreType } from 'models/store.model';
import { getTeamRoles } from 'utils/role-config';
import { ENUM_ALL_ROLES } from 'utils/roles';
import { getDefaultAuthorizedRoute } from 'utils/route-authorization';
import { readStoredPermissions, readStoredRole } from 'utils/authorization';
const StoreSelectionDropdown = ({
  show,
  setShow
}: {
  show: boolean;
  setShow: (arg0: boolean) => void;
}) => {
  const navigate = useNavigate();
  const { setActiveStore, setShowAddStoreModal, activeStore, stores, setShowStores } =
    useDashboardContext();
  const changeStore = (store: StoreType) => {
    const roleConfig = getTeamRoles();
    const role = (readStoredRole()?.name ?? '') as ENUM_ALL_ROLES;
    const permissions = readStoredPermissions();
    const fallbackRoute = getDefaultAuthorizedRoute(permissions);
    const roleBaseRoute = roleConfig?.[role]?.baseRoute ?? '';
    const nextRoute = roleBaseRoute.startsWith('/') ? roleBaseRoute : fallbackRoute;
    sessionStorage.setItem(STORAGE_KEYS.ACTIVE_STORE, JSON.stringify(store));
    setActiveStore(store);
    setShowStores(false);
    navigate(nextRoute);
  };
  return (
    <div>
      <div
        onClick={() => setShow(!show)}
        className='flex cursor-pointer justify-between items-center bg-[#F2F2F3] rounded-[12px] py-[14px] px-4 w-full '>
        <div>
          <p className='font-medium text-sm'>{activeStore?.name ?? 'No stores found'}</p>
          <p className='text-[#6F7376] text-xs'>Inventory dashboard</p>
        </div>
        <div className={`text-[#6F7376] cursor-pointer ${show ? 'transform rotate-180' : ''}`}>
          <ArrowDownIcon />
        </div>
      </div>
      <div onClick={() => setShow(!show)}>
        <p className='cursor-pointer text-xs font-[500] bg-yellow-3 text-yellow-7 w-fit mt-1 rounded-[8px] py-1 px-2'>
          Click here to select store
        </p>
      </div>
      {show && (
        <div className='shadow-storeDropdownBoxShadow radius-[8px] pb-[17px] pt-[12px] mt-3'>
          <div className='w-full px-4 '>
            <p className='text-gray-9 text-sm  mb-3 '>Switch Store</p>
            {stores?.map((store, i) => (
              <div
                key={i}
                onClick={() => changeStore(store)}
                className=' hover:bg-[#F2F2F3] py-2 px-[10px] radius-[4px] flex justify-between items-center radius-[12px]'>
                <div className='flex gap-2 items-center'>
                  {store.logo ? (
                    <img className='w-[24px] h-[24px] rounded' src={store.logo} />
                  ) : (
                    <div className='bg-red-5 rounded-[4px]  w-[24px] h-[24px] flex justify-center items-center'>
                      <p className='text-xs font-medium uppercase text-white'>
                        {store?.name[0]}
                        {store?.name[1]}
                      </p>
                    </div>
                  )}

                  <p className='text-sm'>{store?.name}</p>
                </div>
                {activeStore?.id === store?.id && <RmxCheckIcon className='text-[#6F7376]' />}
              </div>
            ))}
          </div>
          <button
            onClick={() => {
              setShowAddStoreModal(true);
            }}
            className='flex gap-3 items-center px-4 mt-6 cursor-pointer'>
            <AddIcon />
            <p className='text-xs'>Add New Store</p>
          </button>
          <div className='border-t mt-9 border-[#EFF0F0]'>
            <Link
              to={MAIN_STORE_ROUTE_KEYS.GENERAL_STORE_DASHBOARD}
              className='flex gap-1 items-center px-4 mt-4 text-xs w-full cursor-pointer '>
              <GeneralDashboardIcon />
              General store dashboard
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreSelectionDropdown;
